<template>
  <div class="news-list-base">
    <div class="wrap" v-if="!!newsList && newsList.length > 0">
      <div
        class="group-list"
        v-for="(grp, gidx) in separatedList"
        :key="`g${gidx}`"
      >
        <h2>{{grp.title}}</h2>
        <div
          class="news-item"
          v-for="(item, idx) in grp.items"
          :key="idx"
          @click="onNewsItemClick(item.id)"
        >
          <span class="news-datetime"><span class="datetime">{{item.opened_at | formatDatetime}}</span><span v-if="+item.readed === 0" class="lbl-new">NEW</span></span>
          <span class="news-title">{{item.title}}</span>
        </div>
      </div>
    </div>
    <div class="no-list" v-else>
      <span>お知らせがありません</span>
      <link-button
        link="/"
        buttonFace="トップページへ戻る"
        design="ghost"
        class="btn-return"
        @click="onReturnTop"
      />
    </div>
  </div>
</template>

<script>
import LinkButton from '@/utvStore/components/partials/LinkButton'
const NEWS_GROUP_MASTER = {
  id0: { id: 0, title: 'お知らせ', },
  id1: { id: 1, title: 'キャンペーン', },
}

export default {
  name: 'NewsList',
  components: {
    LinkButton,
  },
  props: {
    newsListTitle: {
      type: String,
      default: ''
    },
    newsList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    separatedList() {
      const rtn = []
      if(!!this.newsList && this.newsList.length > 0) {
        this.newsList.forEach((item, idx) => {
          let tgtGrp = +item.type
          let tgtData = rtn.find(item => item.id === tgtGrp)
          if (!tgtData) {
            const tgtMaster = `id${tgtGrp}` in NEWS_GROUP_MASTER ? NEWS_GROUP_MASTER[`id${tgtGrp}`] : null
            if (!!tgtMaster) {
              rtn.push({
                ...tgtMaster,
                items: [{...item}]
              })
            }
          } else {
            tgtData.items.push({...item})
          }
        })
      }
      return rtn
    }
  },
  methods: {
    onNewsItemClick(val){
      location.href = `/news/${val}`
    },
    onReturnTop(){
      location.href = '/'
    }
  },
  filters: {
    formatDatetime(val){
      const dt = new moment(val)
      if(dt.isValid()){
        return `${dt.format('YYYY年MM月DD日 H時mm分')}`
      }
      return ''
    }
  }
}</script>

<style scoped lang="scss">
@import '../../../../sass/commons/commonVariables.scss';

.news-list-base {
  width: 100%;
  padding: 24px 8px;
  background: white;
  .wrap {
    width: 100%;
  }
  .no-list {
    display: flex;
    height: 300px;
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 10px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 16px;
    span {
      display: block;
      margin-bottom: 40px;
    }
    .btn-return {
      max-width: 300px;
    }
  }
  .group-list {
    padding: 0 0 32px;
    @include mq('w580'){
      padding:  0 0 60px;
    }
    h2 {
      width: 100%;
      text-align: center;
      margin: 0;
      @include mq('w580'){
        margin: 0 0 16px;
      }
    }
  }
  .news-item {
    width: 100%;
    border-bottom: 1px solid rgba(184, 184, 184, 0.17);
    padding: 24px 40px 24px 16px;;
    min-height: 100px;
    position: relative;
    cursor: pointer;
    .news-datetime {
      display: flex;
      font-size: 14px;
      width: 100%;
      align-items: center;
      margin-bottom: 6px;
    }
    .news-title {
      width: 100%;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.4;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /* autoprefixer: ignore next */
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    &::after {
      $size: 10px;
      content: "";
      display: inline-block;
      width: $size;
      height: $size;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 16px;
      margin: auto;
      border-top: 2px solid #c4c4c4;
      border-right: 2px solid #c4c4c4;
      transform: rotate(45deg);
    }
  }
}

.lbl-new {
  display: inline-block;
  color: white;
  background: linear-gradient(86.53deg, #FF7497 21.4%, #CB8BFF 76.64%);
  padding: 4px 6px;
  font-size: 10px;
  border-radius: 5px;
  font-weight: bold;
  line-height: 1;
  margin-left: 8px;
}

.btn {
  display: flex;
  background: white;
  border: 3px solid #ff7497;
  color: #ff7497;
  justify-content: center;
  align-items: center;
  width: 300px;
  border-radius: 30px;
  padding: 8px 0;
  text-align: center;
  font-weight: bold;
  text-decoration: none;
  margin: 8px auto;
  line-height: 1.4;
  height: 54px;
  max-height: 60px;
}


</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/News/NewsList.vue